
































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import ImageSelector from '@/components/ImageSelector.vue';
import S3Image from '@/components/S3Image.vue';
@Component({
  components: {S3Image, ImageSelector},
})
export default class DlgPostsNew extends Vue {
  public $refs!: {
    form: any,
  };

  @Action('admin/posts/create') private createPost!: any;
  @Action('admin/posts/read') private readPosts!: any;
  @Action('admin/animals/read') private readAnimals!: any;
  @Action('admin/posts/uploadImage') private uploadImage!: any;
  @Getter('common/rules/all') private rules!: any;
  @Getter('admin/animals/all') private animals!: any;

  private post: any = {};
  private postImage: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;
  private selected: string = '';

  @Watch('dialog')
  private async changedDialogValue(val: boolean) {
    if (val) {
      this.loading = true;
      await this.readAnimals();
      this.loading = false;
    }
  }

  private async save() {
    if (this.$refs.form.validate() && this.selected) {
      this.loading = true;

      this.post.animalId = this.selected;
      this.post.images = [await this.uploadImage({ animalId: this.post.animalId, image: this.postImage })];

      this.createPost(this.post)
        .then((success: any) => {
          if (success) {
            return this.readPosts();
          }
          throw new Error();
        })
        .then(() => {
          this.loading = false;
          this.dialog = false;
          this.post = {};
          this.$refs.form.resetValidation();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
}
